<template>
  <li :class="linkClasses">
    <div v-if="href === '' || !href">
      <slot></slot>
      <span v-if="!showSeparator" :class="separatorClasses" v-html="separator"></span>
    </div>

    <a v-else href="javascript:void(0);" @click="$_onClick">
      <slot></slot>
      <span v-if="!showSeparator" :class="separatorClasses" v-html="separator"></span>
      <span v-else :class="separatorClasses">
        <slot name="separator"></slot>
      </span>
    </a>
  </li>
</template>
<script>
import * as constants from '../../utils/constants'

const PREFIX_BREADCRUMB_CLASS = `${constants.PREFIX_CLASS}breadcrumb`

export default {
  name: 'TBreadcrumbItem',
  props: {
    href: {
      type: String
    },
    replace: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lastChild: false,
      separator: '',
      showSeparator: false
    }
  },
  computed: {
    linkClasses() {
      return [
        `${PREFIX_BREADCRUMB_CLASS}__item`,
        {
          active: this.href === this.$router.currentRoute.fullPath
        }
      ]
    },
    separatorClasses() {
      return `${PREFIX_BREADCRUMB_CLASS}__separator`
    }
  },
  mounted() {
    this.showSeparator = this.$slots.separator !== undefined
  },
  methods: {
    $_onClick() {
      let isRoute = this.$router
      if (!this.href || this.href === '') {
        return
      }
      if (isRoute) {
        this.replace
          ? this.$router.replace(this.href)
          : this.$router.push(this.href)
      } else {
        window.location.href = this.href
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// breadcrumb-item.vue?1328870e